var map = {
	"./app.js": "AVgI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DJLs";


//////////////////
// WEBPACK FOOTER
// ./src/vms/store/modules nonrecursive \.js$
// module id = DJLs
// module chunks = 1